import React, {Fragment} from "react";
import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {UserTypes} from "root/globals";

const DropdownUserTypes2 = ({onChange, control, name, rules, placeholder, isSearchable, isClearable, readOnly}) =>
{
    const fields = { url: '/school360/usertypes?role=' + UserTypes.USER_TYPE_SCHOOL_ADMIN, keyFieldName: 'type_id', labelFieldName: 'display_name' }

    const [ isLoading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            {isLoading === true && <div className='form-control'><SpinnerDiv/></div>}
            {isLoading === false && <CommonDropdown items={items} control={control} name={name} rules={rules}
                                                    onChange={onChange} readOnly={readOnly}
                                                    isSearchable={isSearchable} isClearable={isClearable}
                                                    placeholder={placeholder}/>}
        </Fragment>
    )
}
export default DropdownUserTypes2;
